// Native details and ordinary links work before this progressive enhancement.
const navigationDisclosures = [...document.querySelectorAll('[data-nav-disclosure]')];
function closeNavigation(disclosure, restoreFocus = false) {
  disclosure.open = false;
  if (restoreFocus) disclosure.querySelector('summary')?.focus();
}
for (const disclosure of navigationDisclosures) {
  const summary = disclosure.querySelector('summary');
  summary?.setAttribute('aria-expanded', String(disclosure.open));
  disclosure.addEventListener('toggle', () => {
    summary?.setAttribute('aria-expanded', String(disclosure.open));
    if (disclosure.classList.contains('mobile-navigation')) summary?.setAttribute('aria-label', disclosure.open ? 'Close navigation' : 'Open navigation');
  });
  disclosure.addEventListener('focusout', () => {
    setTimeout(() => { if (!disclosure.contains(document.activeElement) && !disclosure.classList.contains('mobile-navigation')) closeNavigation(disclosure); }, 0);
  });
}
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  for (const disclosure of navigationDisclosures) if (disclosure.open) closeNavigation(disclosure, true);
});
document.addEventListener('click', event => {
  for (const disclosure of navigationDisclosures) if (disclosure.open && !disclosure.contains(event.target)) closeNavigation(disclosure);
});
const compactNavigation = matchMedia('(max-width: 960px)');
compactNavigation.addEventListener('change', () => navigationDisclosures.forEach(disclosure => closeNavigation(disclosure)));

// Hover supplements native click/keyboard disclosure, only on wide fine pointers.
const hoverNavigation = matchMedia('(min-width: 961px) and (hover: hover) and (pointer: fine)');
const collectionsPair = document.querySelector('.collections-nav-pair');
const collectionsDisclosure = collectionsPair?.querySelector('[data-nav-disclosure]');
const navigationHeader = collectionsPair?.closest('.site-header');
let hoverCloseTimer;
function cancelHoverClose() { clearTimeout(hoverCloseTimer); }
function closeHoveredCollections() {
  cancelHoverClose();
  if (collectionsDisclosure && !collectionsDisclosure.contains(document.activeElement)) closeNavigation(collectionsDisclosure);
}
collectionsPair?.addEventListener('pointerenter', event => {
  if (!hoverNavigation.matches || event.pointerType === 'touch') return;
  cancelHoverClose();
  collectionsDisclosure.open = true;
});
// The header contains the menu and the gap above it, so crossing that gap stays open.
navigationHeader?.addEventListener('pointerenter', cancelHoverClose);
navigationHeader?.addEventListener('pointerleave', () => {
  if (hoverNavigation.matches) hoverCloseTimer = setTimeout(closeHoveredCollections, 180);
});
document.querySelector('.main-nav')?.addEventListener('pointerover', event => {
  if (hoverNavigation.matches && !collectionsPair?.contains(event.target)) closeHoveredCollections();
});
hoverNavigation.addEventListener('change', () => { cancelHoverClose(); if (collectionsDisclosure) closeNavigation(collectionsDisclosure); });

// Preview images live in inert templates until selected. Links remain native.
const collectionsMenu = document.querySelector('#CollectionsMenu');
const collectionPreview = collectionsMenu?.querySelector('[data-collection-preview] .curated-card');
const collectionMenuLinks = [...(collectionsMenu?.querySelectorAll('[data-collection-menu-link]') || [])];
if (collectionPreview) {
  const previewArt = collectionPreview.querySelector('.curated-card-art');
  const previewTitle = collectionPreview.querySelector('h3');
  const previewCount = collectionPreview.querySelector('.curated-count');
  const defaultPreview = {
    href: collectionPreview.getAttribute('href'),
    title: previewTitle.textContent,
    count: previewCount.textContent,
    artwork: previewArt.cloneNode(true)
  };
  let previewRequest = 0;
  let requestedLink;
  function resetCollectionPreview() {
    previewRequest++;
    requestedLink = undefined;
    collectionPreview.setAttribute('href', defaultPreview.href);
    previewTitle.textContent = defaultPreview.title;
    previewCount.textContent = defaultPreview.count;
    previewArt.replaceChildren(...defaultPreview.artwork.cloneNode(true).childNodes);
    collectionMenuLinks.forEach(link => link.classList.remove('is-previewed'));
  }
  async function showCollectionPreview(link) {
    if (!collectionsDisclosure?.open || link === requestedLink) return;
    const sourceImage = link.querySelector('template[data-collection-preview-image]')?.content.querySelector('img');
    if (!sourceImage) return;
    // Import into the active document so an inert template image can fetch/decode.
    const image = document.importNode(sourceImage, true);
    requestedLink = link;
    const request = ++previewRequest;
    image.loading = 'eager';
    try {
      await image.decode();
    } catch {
      if (request === previewRequest) requestedLink = undefined;
      return; // Retain the complete previous preview on a failed image request.
    }
    if (request !== previewRequest || !collectionsDisclosure.open) return;
    previewArt.replaceChildren(image);
    collectionPreview.setAttribute('href', link.getAttribute('href'));
    previewTitle.textContent = link.querySelector('.curated-menu-label').textContent.trim();
    previewCount.textContent = `${link.dataset.collectionCount} prints`;
    collectionMenuLinks.forEach(item => item.classList.toggle('is-previewed', item === link));
  }
  for (const link of collectionMenuLinks) {
    link.addEventListener('pointerenter', event => {
      if (hoverNavigation.matches && event.pointerType !== 'touch') showCollectionPreview(link);
    });
    link.addEventListener('focus', () => showCollectionPreview(link));
  }
  collectionsDisclosure?.addEventListener('toggle', () => {
    if (!collectionsDisclosure.open) resetCollectionPreview();
  });
}
